import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import NotificationConnectionKpi from '../../components/Notifications/NotificationConnectionKpi';
import WarningNotification from "../../components/Notifications/WarningNotification";
import AddWhatsAppTemplatePermissions from "../../components/AddWhatsAppTemplatePermissions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark,
    faEyeSlash,
    faEye
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import Select from "react-select";
import Loader from "../../components/Loader";

const WhatsAppForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const { contract } = location.state || {};
    const [ruc, setCif] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [name, setNombre] = useState("");
    const [lastName, setApellido] = useState("");
    const [email, setEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmarClave, setConfirmarClave] = useState("");
    const [userName, setUserName] = useState("");
    const [moduleTemplatesId, setModuleTemplatesId] = useState("");
    const [planId, setPlanId] = useState("");
    const [month, setMonth] = useState("");
    const [userId, setUserId] = useState(0);
    const [serviceType, setServiceType] = useState("");
    const [accountType, setAccountType] = useState("");
    const [cloudPhoneNumberId, setCloudPhoneNumberId] = useState("");
    const [cloudAppId, setCloudAppId] = useState("");
    const [cloudAccessToken, setCloudAccessToken] = useState("");
    const [cloudAppSecret, setCloudAppSecret] = useState("");
    const [cloudDefaultTemplateName, setCloudDefaultTemplateName] = useState("");
    const [cloudDefaultTemplateLanguage, setCloudDefaultTemplateLanguage] = useState("");
    const [cloudWabaId, setCloudWabaId] = useState("");
    const [templatePermissions, setTemplatePermissions] = useState("");
    const [idRegistro, setIdRegistro] = useState(0);
    const [makiId, setMakiId] = useState(0);
    const [options, setOptions] = useState([]);
    const [mensaje, setMensaje] = useState(0);
    const [isSuccessNotifVisible, setIsSuccessNotifVisible] = useState(false);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const [isWarningVisible, setIsWarningVisible] = useState(false);
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);
    const [loading, setLoading] = useState(false);
    const [makiToken, setMakiToken] = useState("");


    useEffect(() => {
        if (id) {
            const fetchProduct = async () => {
                try {
                    const response = await apiClient.get(`/whatsappDetails/detail/${id}`);
                    setNombre(response.data.name);
                    setApellido(response.data.lastName);
                    setCif(response.data.ruc);
                    setPhoneNumber(response.data.phoneNumber.substring(3));
                    setUserName(response.data.userName);
                    setEmail(response.data.email);
                    setPassword(response.data.password);
                    setUserId(response.data.makiUserId);
                    setMakiToken(response.data.makiApiKey);
                    setServiceType(response.data.serviceType);
                    setAccountType(response.data.accountType);
                    setCloudPhoneNumberId(response.data.cloudPhoneNumberId);
                    setCloudAppId(response.data.cloudAppId);
                    setCloudAccessToken(response.data.cloudAccessToken);
                    setCloudAppSecret(response.data.cloudAppSecret);
                    setCloudDefaultTemplateName(response.data.cloudDefaultTemplateName);
                    setCloudDefaultTemplateLanguage(response.data.cloudDefaultTemplateLanguage);
                    setCloudWabaId(response.data.cloudWabaId);
                    const plan = await apiClient.get(`/module_pack/${response.data.moduleTemplatesId}`);
                    if (plan.data && plan.data.length > 0) {
                        const selectedPlanId = plan.data[0].id.toString();
                        setModuleTemplatesId(selectedPlanId);
                        setPlanId(plan.data[0].makiSubscriptionsId);
                        setMonth(plan.data[0].paymentPeriod);
                    }
                } catch (error) {
                    console.error("Error al cargar el Usuario", error);
                }
            };
            fetchProduct();
        }
    }, [id]);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };
    const handleClick = () => {
        navigate(-1);
    };

    const toggleShowPassword2 = () => {
        setShowPassword2((prevShowPassword) => !prevShowPassword);
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    const fetchAuthToken = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_CIFRUC_URL}/login`,
                {
                    method: "GET",
                    headers: {
                        Authorization: "Basic " + btoa("fenix:7&m$T8v_12d6?aA}yVOF"),
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Error al obtener el token");
            }

            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error("Error al obtener el token:", error);
            return null;
        }
    };

    const handleDocumentSearch = async (event) => {
        if (event.key === "Enter" || event.key === "Tab") {
            event.preventDefault();
            try {
                // Obtén el token primero
                setLoading(true);
                const token = await fetchAuthToken();
                if (!token) {
                    throw new Error("No se pudo obtener el token de autenticación");
                }
                const response = await fetch(
                    `${process.env.REACT_APP_CIFRUC_URL}/document/search`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            contract: contract,
                            document: ruc,
                        }),
                    }
                );
                if (!response.ok) {
                    throw new Error("Error en la búsqueda del documento");
                }
                const data = await response.json();
                if (data.document && data.document.socialReason) {
                    setIsWarningVisible(false);
                    setIsErrorVisible(false);
                    setIsButtonDisabled(false);
                    const palabras = data.document.socialReason.trim().split(/\s+/);
                    const apellido = palabras.slice(0, 2).join(" ");
                    const nombre = palabras.slice(-2).join(" ");
                    setApellido(apellido);
                    setNombre(nombre);
                }
                if (data.document && data.document.email) {
                    setEmail(data.document.email);
                } else {
                    setEmail("");
                }
            } catch (error) {
                setErrorMessage(
                    "El Documento de Identificación ingresado es Incorrecto o No Existe."
                );
                setIsErrorVisible(true);
                setIsButtonDisabled(true);
                if (ruc.length === 10 && /^[0-9]+$/.test(ruc)) {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                } else if (ruc.length === 13 && /^[0-9]+$/.test(ruc)) {
                    setErrorMessage(
                        "El Documento de Identificación ingresado es Incorrecto o No Existe."
                    );
                    setIsErrorVisible(true);
                    setIsButtonDisabled(true);
                } else if (/[^0-9]/.test(ruc)) {
                    setWarningMessage(
                        "El Documento de Identificación ingresado es un Pasaporte."
                    );
                    setIsWarningVisible(true);
                    setIsButtonDisabled(false);
                }

            } finally {
                setLoading(false);
            }
        }
    };
    const handleCifChange = (e) => {
        const value = e.target.value;
        setCif(value);
        if (value === "") {
            setNombre("");
            setApellido("");
            setEmail("");
            setIsWarningVisible(false);
            setIsErrorVisible(false);
            setIsButtonDisabled(false);
        }
    };

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await apiClient.get("/module_pack?productType=SUBSCRIPTIONS&moduleCode=WHATSAPP");
                const formattedOptions = response.data.map((item) => ({
                    value: item.id.toString(),
                    label: item.description,
                    makiSubscriptionsId: item.makiSubscriptionsId,
                    paymentPeriod: item.paymentPeriod,
                }));
                setOptions(formattedOptions);
            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        };

        fetchOptions();
    }, []);

    const handleWhatsAppChange = (selectedOption) => {
        if (selectedOption) {
            setModuleTemplatesId(selectedOption.value); // id
            setPlanId(selectedOption.makiSubscriptionsId); // planId
            setMonth(selectedOption.paymentPeriod); // meses
        } else {
            setModuleTemplatesId("");
            setPlanId("");
            setMonth("");
        }
    };

    const validateEmail = (email) => {
        // Expresión regular para validar el formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email); // Solo valida el formato del correo
    };
    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        // Validar el email
        if (!validateEmail(value)) {
            setErrors({
                email: 'Email inválido. Debe contener "@" y un dominio válido.',
            });
        } else {
            setErrors({});
        }
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!ruc) validationErrors.ruc = "El Campo es Obligatorio";
        if (!phoneNumber) validationErrors.phoneNumber = "El Campo es Obligatorio";
        if (!name) validationErrors.name = "El Campo es Obligatorio";
        if (!lastName) validationErrors.lastName = "El Campo es Obligatorio";
        if (!email) validationErrors.email = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (!confirmarClave) validationErrors.confirmarClave = "El Campo es Obligatorio";
        if (!userName) validationErrors.userName = "El Campo es Obligatorio";
        if (!moduleTemplatesId) validationErrors.moduleTemplatesId = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (password !== confirmarClave) {
            validationErrors.confirmarClave = "Las claves no coinciden";
        }
        if (serviceType === "cloud") {
            if (!cloudPhoneNumberId) validationErrors.cloudPhoneNumberId = "El Campo es Obligatorio";
        }
        if (accountType === "custormer_private") {
            if (!cloudAppId) validationErrors.cloudAppId = "El Campo es Obligatorio";
            if (!cloudAccessToken) validationErrors.cloudAccessToken = "El Campo es Obligatorio";
            if (!cloudAppSecret) validationErrors.cloudAppSecret = "El Campo es Obligatorio";
            if (!cloudDefaultTemplateName) validationErrors.cloudDefaultTemplateName = "El Campo es Obligatorio";
            if (!cloudDefaultTemplateLanguage) validationErrors.cloudDefaultTemplateLanguage = "El Campo es Obligatorio";
            if (!cloudWabaId) validationErrors.cloudWabaId = "El Campo es Obligatorio";
        }
        return validationErrors;
    };

    const isHandleCloseSuccess = () => {
        setIsSuccessNotifVisible(false);
        setTemplatePermissions(true);
        //navigate(-1);
    };

    const closeWhatsappPermisionsModal = () => {
        setTemplatePermissions(false);
        navigate(-1);
    };
    const handleSave = async () => {
        const today = new Date();
        const formattedDate = format(today, "yyyy-MM-dd HH:mm:ss");
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            setLoading(true);
            let response;
            if (id) {
                const payloadUpdate = {
                    moduleTemplatesId,
                    password,
                    phoneNumber: "593" + phoneNumber,
                    planId,
                    month,
                    userId,
                    serviceType,
                    accountType,
                    cloudPhoneNumberId,
                    cloudAppId,
                    cloudAccessToken,
                    cloudAppSecret,
                    cloudDefaultTemplateName,
                    cloudDefaultTemplateLanguage,
                    cloudWabaId
                };
                response = await apiClient.patch(
                    `/whatsappDetails/${id}`,
                    payloadUpdate
                );
                if (response.status === 201) {
                    const register = `Nro. Contrato: ${contract}
                        RUC: ${ruc}
                        Razón Social: ${name + " " + lastName}
                        Usuario: ${userName}
                        Nro. Celular: ${phoneNumber}
                        Contraseña: ${password}
                        Token: ${makiToken}`;
                    setIdRegistro(id);
                    setMakiId(userId);
                    setMensaje(register);
                    setIsSuccessNotifVisible(true);
                }
            } else {

                const payloadWhatsApp = {
                    moduleTemplatesId,
                    numCont: contract,
                    userName,
                    name,
                    lastName,
                    password,
                    email,
                    phoneNumber: "593" + phoneNumber,
                    grupo: "user",
                    platform: "whatsapp",
                    planId,
                    month,
                    ruc,
                    flagActive: true,
                    fechaIni: formattedDate,
                    serviceType,
                    accountType,
                    cloudPhoneNumberId,
                    cloudAppId,
                    cloudAccessToken,
                    cloudAppSecret,
                    cloudDefaultTemplateName,
                    cloudDefaultTemplateLanguage,
                    cloudWabaId
                };
                response = await apiClient.post("/whatsappDetails", payloadWhatsApp);
                if (response.status === 201) {
                    const register = `Nro. Contrato: ${contract}
                        RUC: ${ruc}
                        Razón Social: ${name + " " + lastName}
                        Usuario: ${response.data?.userName}
                        Nro. Celular: ${response.data?.phoneNumber}
                        Contraseña: ${response.data?.password}
                        Token: ${response.data?.token}`;
                    setIdRegistro(response.data?.id);
                    setMakiId(response.data?.makiId);
                    setMensaje(register);
                    setIsSuccessNotifVisible(true);
                }
            }
        } catch (error) {

            const message = error.response?.data?.message;

            if (error.response?.status === 401) {
                setIsLoginVisible(true);

            } else if (message?.startsWith("PHONE_NUMBER_ALREADY_EXIST")) {
                setMessageBlock(`El Número de Celular ingresado ya existe.`);
                setNotificationBlock(true);

            } else if (message?.startsWith("USERNAME_ALREADY_EXISTS")) {
                setMessageBlock(`El Usuario ingresado ya existe.`);
                setNotificationBlock(true);
            }
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Plan de WhatsApp" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={handleClick}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Plan de WhatsApp</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.numContId ? "red" : "revert-layer" }}>Número de Contrato</label>
                        <input
                            type="text"
                            placeholder="Contrato"
                            value={contract}
                            readOnly
                        />
                        {errors.numContId && <p className="error-message">{errors.numContId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.ruc ? "red" : "revert-layer" }}>
                            Documento de Identificación
                        </label>
                        <input
                            type="text"
                            placeholder="Documento de Identificación"
                            value={ruc}
                            onChange={handleCifChange}
                            onKeyDown={handleDocumentSearch}
                            readOnly={!!id}
                        />
                        {errors.ruc && <p className="error-message">{errors.ruc}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.name ? "red" : "revert-layer" }}>
                            Nombre
                        </label>
                        <input
                            type="text"
                            placeholder="Nombre"
                            value={name}
                            onChange={(e) => setNombre(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.lastName ? "red" : "revert-layer" }}>
                            Apellido
                        </label>
                        <input
                            type="text"
                            placeholder="Apellido"
                            value={lastName}
                            onChange={(e) => setApellido(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.lastName && <p className="error-message">{errors.lastName}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors?.moduleTemplatesId ? "red" : "revert-layer" }}>Plan</label>
                        <Select
                            value={
                                moduleTemplatesId
                                    ? options.find((option) => option.value === moduleTemplatesId)
                                    : null
                            }
                            onChange={handleWhatsAppChange}
                            options={options}
                            placeholder="Seleccione un módulo"
                            isClearable
                            classNamePrefix="custom-select"
                            className="custom-select-container"
                        />
                        {errors?.moduleTemplatesId && <p className="error-message">{errors.moduleTemplatesId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors?.phoneNumber ? "red" : "revert-layer" }}>Número de Celular</label>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "0 10px",
                                    backgroundColor: "transparent",
                                    border: "1px",
                                    borderRight: "none",
                                    borderRadius: "4px 0 0 4px"
                                }}
                            >
                                <img
                                    src="https://flagcdn.com/w40/ec.png"
                                    alt="EC"
                                    style={{ width: "20px", height: "14px", marginRight: "6px" }}
                                />
                                +593
                            </span>
                            <input
                                type="text"
                                name="numeroCelular"
                                placeholder="Ej. 987654321"
                                className="form-control"
                                style={{ borderRadius: "0 4px 4px 0" }}
                                value={phoneNumber}
                                maxLength={9}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d{0,9}$/.test(value)) {
                                        setPhoneNumber(value);
                                    }
                                }}
                            />
                        </div>
                        {errors?.phoneNumber && <p className="error-message">{errors.phoneNumber}</p>}
                    </div>

                    <div className="basic-info-form-group">
                        <label style={{ color: errors.email ? "red" : "revert-layer" }}>
                            {" "}
                            Email
                        </label>
                        <input
                            type="text"
                            placeholder="Email"
                            value={email}
                            onChange={handleChange}
                            readOnly={!!id}
                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.userName ? "red" : "revert-layer" }}>
                            {" "}
                            Nombre de Usuario
                        </label>
                        <input
                            type="text"
                            placeholder="Nombre de Usuario"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.userName && <p className="error-message">{errors.userName}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                            Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Contraseña"
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword}
                            />
                        </div>
                        {errors.password && <p className="error-message">{errors.password}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                            Confirmar Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword2 ? "text" : "password"}
                                placeholder="Confirmar Clave"
                                value={confirmarClave}
                                onChange={(e) => setConfirmarClave(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showPassword2 ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword2}
                            />
                        </div>
                        {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label>Tipo</label>
                        <select
                            value={serviceType}
                            onChange={(e) => setServiceType(e.target.value)}
                        >
                            <option value="">Seleccione una opción</option>
                            <option value="web">Web</option>
                            <option value="cloud">Cloud</option>
                        </select>
                    </div>
                    {serviceType === "cloud" && (
                        <>
                            <div className="basic-info-form-group">
                                <label style={{ color: errors.cloudPhoneNumberId ? "red" : "revert-layer" }}>
                                    ID Nro. Celular
                                </label>
                                <input
                                    type="text"
                                    placeholder="ID Nro. Celular"
                                    value={cloudPhoneNumberId}
                                    onChange={(e) => setCloudPhoneNumberId(e.target.value)}
                                />
                                {errors.cloudPhoneNumberId && <p className="error-message">{errors.cloudPhoneNumberId}</p>}
                            </div>
                            <div className="basic-info-form-group">
                                <label>Tipo Cuenta</label>
                                <select
                                    value={accountType}
                                    onChange={(e) => setAccountType(e.target.value)}
                                >
                                    <option value="">Seleccione una opción</option>
                                    <option value="custormer_private">Personal</option>
                                    <option value="fnx_corporate">Corporativo</option>
                                </select>
                            </div>
                            {accountType === "custormer_private" && (
                                <>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.cloudAccessToken ? "red" : "revert-layer" }}>
                                            Token
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Token"
                                            value={cloudAccessToken}
                                            onChange={(e) => setCloudAccessToken(e.target.value)}
                                        />
                                        {errors.cloudAccessToken && <p className="error-message">{errors.cloudAccessToken}</p>}
                                    </div>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.cloudAppId ? "red" : "revert-layer" }}>
                                            ID META
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="id META"
                                            value={cloudAppId}
                                            onChange={(e) => setCloudAppId(e.target.value)}
                                        />
                                        {errors.cloudAppId && <p className="error-message">{errors.cloudAppId}</p>}
                                    </div>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.cloudAppSecret ? "red" : "revert-layer" }}>
                                            CLAVE META
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Clave META"
                                            value={cloudAppSecret}
                                            onChange={(e) => setCloudAppSecret(e.target.value)}
                                        />
                                        {errors.cloudAppSecret && <p className="error-message">{errors.cloudAppSecret}</p>}
                                    </div>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.cloudDefaultTemplateName ? "red" : "revert-layer" }}>
                                            Nombre Plantilla
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Nombre Plantilla"
                                            value={cloudDefaultTemplateName}
                                            onChange={(e) => setCloudDefaultTemplateName(e.target.value)}
                                        />
                                        {errors.cloudDefaultTemplateName && <p className="error-message">{errors.cloudDefaultTemplateName}</p>}
                                    </div>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.cloudDefaultTemplateLanguage ? "red" : "revert-layer" }}>
                                            Idioma Plantilla
                                        </label>

                                        <select
                                            value={cloudDefaultTemplateLanguage}
                                            onChange={(e) => setCloudDefaultTemplateLanguage(e.target.value)}
                                        >
                                            <option value="">Seleccione un idioma</option>
                                            <option value="es">Español</option>
                                            <option value="eng">Inglés</option>
                                            <option value="por">Portugués</option>
                                            <option value="fra">Francés</option>
                                            <option value="deu">Alemán</option>
                                            <option value="ita">Italiano</option>
                                        </select>

                                        {errors.cloudDefaultTemplateLanguage && (
                                            <p className="error-message">{errors.cloudDefaultTemplateLanguage}</p>
                                        )}
                                    </div>
                                    <div className="basic-info-form-group">
                                        <label style={{ color: errors.dbHost ? "red" : "revert-layer" }}>
                                            Id Cuenta Empresarial de WhatsApp
                                        </label>
                                        <input
                                            type="text"
                                            placeholder=" Id Cuenta Empresarial de WhatsApp"
                                            value={cloudWabaId}
                                            onChange={(e) => setCloudWabaId(e.target.value)}
                                        />
                                        {errors.dbHost && <p className="error-message">{errors.dbHost}</p>}
                                    </div>


                                </>
                            )}

                        </>
                    )}

                </div>

                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/UsersList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                        disabled={isButtonDisabled}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            {loading && <Loader />}
            <SuccessNotification
                message={
                    id
                        ? "El Usuario se ha Actualizado Correctamente."
                        : "El Usuario se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuele a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            <WarningNotification
                message={warningMessage}
                isVisible={isWarningVisible}
                onClose={() => setIsWarningVisible(false)}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Plan de WhatsApp debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={-1}
                    whatsApp={false}
                />
            )}
            {isSuccessNotifVisible && (
                <NotificationConnectionKpi
                    message={`Los datos de conexión son:`}
                    men1={mensaje}  // Pasando men1 como prop
                    isVisible={isSuccessNotifVisible}
                    onClose={isHandleCloseSuccess}
                    enca={id ? "Actualizado Correctamente" : false}
                />
                // 
            )}

            {templatePermissions && (
                <AddWhatsAppTemplatePermissions
                    isVisible={templatePermissions}
                    onClose={() => closeWhatsappPermisionsModal()}
                    id={idRegistro}
                    makiId={makiId}
                />
            )}

        </div>
    );
};

export default WhatsAppForm;
